import React from 'react';
import './style.scss';

const GraphCard = ({ className = '', children }) => {
	return <div className={`graph-card__container ${className}`}>{children}</div>;
};

export default GraphCard;
